<template>
  <div class="content-wrapper" style="min-height: 481px;">
    <section class="content-header">
      <h1>
        {{ $t('dashboard.title') }}
        <small>{{ $t('dashboard.subtitle') }}</small>
      </h1>
      <ol class="breadcrumb">
        <li class="active"><i class="fa fa-dashboard"></i> Dashboard</li>
      </ol>
    </section>

    <section class="content container-fluid">
      <div class="row">
        <div class="col-md-12">

          <div v-if="$root.$i18n.locale == 'en'" class="callout callout-info">
            <p>For this Cabinet the term “Sports Camp” is used to describe the organization as a whole. E.g. “Manchester
              City Football Academy”.</p>

            <p>There might be numerous Sports Programs under the single Sports Camp. E.g., “Football camp for boys 10-16
              y.o.”, “Summer football camp for goalies”, etc.</p>

            <p>Each Sports Program might have one or more Dates (e.g., March 1- March 7, 2019; etc.).</p>

          </div>

          <div v-if="$root.$i18n.locale == 'ru'" class="callout callout-info">
            <p>Для корректного отображения информации пользователям сайта, <b>в данном Кабинете</b> используются
              следующие понятия и соответствующие им разделы:</p>
            <p>Спортивный Лагерь - это спортивная организация в целом. Например, “СДЮШОР Самбо-50”.</p>

            <p>В рамках Лагеря может быть множество Спортивных Программ. Например, “Сборы по фигурному катанию для детей
              9-14 лет”, “Летний лагерь по дзюдо для мальчиков 10-15 лет”, и т.д.</p>

            <p>У Спортивной Программы могут быть один или несколько Заездов.</p>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-xs-6">
          <a href="./camps">
          <div class="small-box bg-aqua">
            <div class="inner">
              <h3>{{countCamps}}</h3>
              <p v-if="countCamps !== ''">{{ $tc('dashboard.camps', countCamps) }}</p>
            </div>
            <div class="icon">
              <i class="ion ion-bag"></i>
            </div>
            <a class="small-box-footer">
              {{ $t('dashboard.more-info') }} <i class="fa fa-arrow-circle-right"></i>
            </a>
          </div>
          </a>
        </div>

        <div class="col-lg-3 col-xs-6">
          <a href="./programs">
            <div class="small-box bg-green">
              <div class="inner">
                <h3>{{countPrograms}}</h3>
                <p v-if="countPrograms !== ''">{{ $tc('dashboard.programs', countPrograms) }}</p>
              </div>
              <div class="icon">
                <i class="ion ion-bag"></i>
              </div>
              <a class="small-box-footer">
                {{ $t('dashboard.more-info') }} <i class="fa fa-arrow-circle-right"></i>
              </a>
            </div>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HomeContent',
  data () {
    return {
      countPrograms: '',
      countCamps: ''
    };
  },
  created () {
    let self = this;

    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

    axios.get(window.host + '/dashboard', {headers: { Authorization: AuthStr }})
      .then(function (response) {
        if (response.data.success && response.data.model) {
          self.countCamps = response.data.model.campsCount;
          self.countPrograms = response.data.model.sportProgramsCount;
        }
      })
      .catch(function () {
        // if (error.response.status == 401) {
        //   self.errorMessage = "Неверный логин или пароль";
        // }
      });
  }
};
</script>

<style scoped>

</style>
